<template lang="pug">
div
  b-container
    b-collapse(v-model="collapse" id="collapse-equipment-section" visible)
      b-form
        b-row
          b-col
            b-form-group
              label.samtek-label(for="input-serial") N° de Serie
              template(v-if="loadedSerial === false")
                .serial-search-row
                  .serial-input-wrapper
                    b-icon.serial-search-icon(icon="search" font-scale="1")
                    vue-typeahead-bootstrap.serial-typeahead(
                      v-model="query"
                      :data="equipments"
                      :disabled="n_serie_ov ? true : false"
                      :serializer="e => e.serial_number"
                      @hit="onSerialSelect"
                      @input="serialSearchLimit"
                      :placeholder="formEquipo.serial_number ? formEquipo.serial_number : 'Ej: 76872AFG'"
                    )
                  b-form-invalid-feedback(
                    :state="query.length === 0 || query.length === 15"
                    v-if="query.length > 0 && query.length !== 15"
                  ) El N° de serie debe tener exactamente 15 caracteres (actual: {{ query.length }}).
                  button.samtek-btn-secondary(
                    type="button"
                    v-if="loadedSerial === false && query && query !== ''"
                    @click="setNewSerial"
                    id="btn-crear-equipo"
                    :disabled="query.length !== 15"
                  ) Crear Equipo
              template(v-else-if="loadedSerial === true")
                .d-flex.align-items-center.gap-3
                  span.serial-loaded-text {{ formEquipo.serial_number }}
                  button.samtek-btn-secondary(
                    type="button"
                    @click="loadingSerial"
                    :disabled="(!creating && equipment && equipment.id !== null) || n_serie_ov ? true : false"
                  ) Cambiar Equipo
        .client-form(v-if="formEquipo && formEquipo.serial_number")
          b-row(v-if="!formEquipo.id")
            b-col
              p.samtek-section-subtitle Crear equipo
          b-row
            b-col
              ModelForm(
                :modelo_id="formEquipo.modelo"
                @onModelSelect="setLocalModel"
                :disabled="disabledModel()"
              )
          b-row
            b-col( cols="12" md="4" )
              b-form-group
                label.samtek-label(for="input-power_source") Incluye Cargador
                b-form-select(
                  id="input-power_source"
                  v-model="formEquipo.power_source"
                  :options="chargerOptions"
                  :disabled="!creating && equipment && equipment.id !== null"
                )
            b-col( cols="12" md="4" )
              b-form-group
                label.samtek-label(for="input-hardDriveType") Tipos de Disco Duro
                b-form-select(
                  id="input-hardDriveType"
                  v-model="formEquipo.type_hard_drive"
                  :options="hardDriveTypeOptions"
                  @change="setHardDriveSize"
                  :disabled="!creating && equipment && equipment.id !== null"
                )
            b-col( cols="12" md="4" )
              b-form-group
                label.samtek-label(for="input-hardDriveSize") Disco Duro
                b-form-select(
                  id="input-hardDriveSize"
                  v-model="formEquipo.size_hard_drive"
                  :options="hardDriveOptions"
                  :disabled="!creating && equipment && equipment.id !== null"
                )
          b-row
            b-col( cols="12" md="6" )
              b-form-group
                label.samtek-label(for="input-ram") Ram
                b-form-select(
                  id="input-ram"
                  v-model="formEquipo.total_ram_memorie"
                  :options="ramOptions"
                  :disabled="!creating && equipment && equipment.id !== null"
                )
            b-col( cols="12" md="6" )
              b-form-group
                label.samtek-label(for="input-password") Password
                b-form-input(
                  id="input-password"
                  placeholder="Opcional..."
                  v-model="formEquipo.password"
                  :disabled="!creating && equipment && equipment.id !== null"
                )
          b-row
            b-col( cols="12" )
              b-form-group
                label.samtek-label(for="input-otros-accesorios") Otros Accesorios
                b-form-input(
                  id="input-otros-accesorios"
                  v-model="otrosAccesorios"
                )
      .botones
        .button-wrapper.mt-3.d-flex.justify-content-end
          button.samtek-btn-primary(
            type="button"
            v-if="formEquipo.serial_number"
            @click="onSubmit"
            :disabled="disabledSubmit"
            id="botones-options"
          ) Siguiente paso
          button.samtek-btn-secondary(
            type="button"
            v-if="!creating && equipment && equipment.id"
            @click="creating = true"
          ) Editar
          button.samtek-btn-secondary(
            type="button"
            v-if="creating && equipment && equipment.id"
            @click="creating = false, getEquipment(equipment.id)"
          ) Cancelar
    div(v-if="!collapse && formEquipo.id")
      .d-flex.align-items-center.flex-wrap.gap-1
        label.samtek-label.mb-0 Número de Serie:
        span.mr-2 {{ equipment.serial_number }}
        span.separator //
        label.samtek-label.mb-0.ml-2 Modelo:
        span {{ equipment.modelo_detail.model_name }}
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ModelForm from './EquipmentForm/ModelForm.vue'

import {
  chargerOptions,
  hardDriveOptions,
  ramOptions,
  hardDriveTypeOptions,
} from './options'

export default {
  components: {
    ModelForm,
    VueTypeaheadBootstrap,
  },
  props: ['n_serie_ov'],
  validations: {
    formEquipo: {
      serial_number: { required },
    },
  },
  data() {
    return {
      loadingFromCreated: false,
      equipments: [],
      query: '',
      requestId: 0,
      creating: false,
      disabledSubmit: false,
      collapse: true,
      searchingSerial: false,
      formEquipo: {
        id: null,
        cliente: this.client ? this.client.id : null,
        modelo: null,
        serial_number: null,
        password: null,
        type_hard_drive: null,
        size_hard_drive: null,
        power_source: null,
        total_ram_memorie: null,
        memorie_modules: null,
      },
      formMarca: {
        id: null,
      },
      tipo: null,
      chargerOptions,
      hardDriveOptions,
      ramOptions,
      hardDriveTypeOptions,
      createMarca: false,
      createModel: false,
      loadedSerial: false,
    }
  },
  methods: {
    ...mapActions('EquipmentStore', [
      'createEquipment',
      'editEquipment',
      'searchBySerial',
      'getModels',
      'getBrands',
      'getEquipment',
    ]),
    ...mapMutations('EquipmentStore', ['SET_EQUIPMENT']),
    setNewSerial() {
      try {
        this.loadedSerial = true
        this.creating = true
        this.formEquipo.serial_number = this.query.slice(0, 15)
        this.formEquipo.cliente = this.client.id
        this.SET_EQUIPMENT({ equipment: this.formEquipo })
      } catch {
        this.$bvToast.toast('Ingrese numero de serie.', {
          variant: 'danger',
        })
      }
    },
    serialSearchLimit() {
      // Validación se maneja en el template, no truncar automáticamente
    },
    async serialSearch(serial) {
      this.formEquipo = null
      if (serial && serial.length >= 1) {
        this.searchingSerial = true
        const res = await this.searchBySerial(serial)
        this.searchingSerial = false
        return res.data
          .concat([{ serial_number: serial, id: null }])
          .filter((c) => c.serial_number && c.serial_number.length >= 3)
      }
    },
    disabledModel() {
      if (!this.creating && this.formEquipo.id !== null) {
        return true
      }
    },
    async onSerialSelect(equipo) {
      this.creating = true
      this.formEquipo = equipo
      this.formEquipo.cliente = this.client.id
      if (equipo.id) {
        this.SET_EQUIPMENT({ equipment: equipo })
      }
      await this.getBrands()
      await this.getModels()
      if (equipo.modelo) {
        const modelo = this.models.find((mod) => mod.id === equipo.modelo)
        this.formMarca.id = modelo ? modelo.marca : null
        this.tipo = modelo.tipo_dispositivo
          ? modelo.tipo_dispositivo.nombre
          : null
      }
      this.creating = false
    },
    async onSubmit() {
      if (this.$v.$invalid || !this.formEquipo.modelo) {
        this.$bvToast.toast('Complete todo los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
      } else {
        this.creating = true
        if (!this.formEquipo.id) {
          // Creacion de Equipo
          this.disabledSubmit = true
          await this.createEquipment(this.formEquipo)
          this.creating = false
          if (this.statusRequest) {
            if (
              this.statusRequest.status === 200 ||
              this.statusRequest.status === 201
            ) {
              this.formEquipo = this.statusRequest.data
              this.SET_EQUIPMENT({ equipment: this.formEquipo })
              this.$emit('openSection', true)
              this.collapse = false
              this.$bvToast.toast('Equipo guardado exitosamente', {
                variant: 'success',
              })
              this.isCreatedOT = true
              return
            }
            if (this.statusRequest.status === 400) {
              this.$bvToast.toast(
                `Error al guardar: ${this.statusRequest.data}`,
                {
                  variant: 'danger',
                }
              )
            }
          }
          this.disabledSubmit = false
          // editar/confirmar equipo
        }
        if (this.formEquipo.id) {
          this.disabledSubmit = true
          await this.editEquipment(this.formEquipo)
          this.creating = false
          if (this.statusRequest) {
            if (
              this.statusRequest.status === 200 ||
              this.statusRequest.status === 201
            ) {
              this.formEquipo = this.statusRequest.data
              this.SET_EQUIPMENT({ equipment: this.formEquipo })
              this.$bvToast.toast('Equipo editado exitosamente', {
                variant: 'success',
              })
              this.$emit('openSection', true)
              this.collapse = false
              this.isCreatedOT = true
            }
            if (this.statusRequest.status === 400) {
              this.$bvToast.toast(
                `Error al guardar: ${this.statusRequest.data}`,
                {
                  variant: 'danger',
                }
              )
            }
          }
          this.disabledSubmit = false
        }
      }
    },
    async fetchEquipment() {
      const equipmentId = this.ot?.equipo?.id
      if (!equipmentId) {
        this.SET_EQUIPMENT({ equipment: null })
        return
      }
      await this.getEquipment(equipmentId)
    },
    setLocalModel(model_id) {
      this.formEquipo.modelo = model_id
    },
    setModelValidation() {
      this.$v.formEquipo.modelo.$touch()
    },
    loadingSerial() {
      this.loadedSerial = false
      this.creating = false
      this.query = ''
      this.formEquipo = {
        id: null,
        cliente: this.client ? this.client.id : null,
        modelo: null,
        serial_number: null,
        password: null,
        type_hard_drive: null,
        size_hard_drive: null,
        power_source: null,
        total_ram_memorie: null,
        memorie_modules: null,
      }
      this.SET_EQUIPMENT({ equipment: null })
    },
    setHardDriveSize() {
      if (this.formEquipo.type_hard_drive === 'NOT_VERIFIED') {
        this.formEquipo.size_hard_drive = null
      }
    },
    debouncedSearchSerial: debounce(async function (serial) {
      if (!serial) return
      this.requestId += 1
      const { requestId } = this
      const res = await this.searchBySerial({ serial })
      if (requestId === this.requestId) {
        if (res.length > 0) {
          // Completa los datos encontrados para desplegarlos en el select
          this.equipments = res
        }
        if (this.loadingFromCreated && res.length === 1) {
          this.onSerialSelect(res[0])
          this.loadingFromCreated = false
        }
      }
    }, 500),
  },
  computed: {
    ...mapGetters('EquipmentStore', [
      'brands',
      'models',
      'equipment',
      'statusRequest',
    ]),
    ...mapGetters('OTStore', ['ot']),
    ...mapGetters('ClientStore', ['client']),
    otrosAccesorios: {
      get() {
        return this.$store.getters['OTStore/otrosAccesorios']
      },
      set(val) {
        this.$store.commit('OTStore/SET_OTROS_ACCESORIOS', val)
      },
    },
    brandOptions() {
      return this.brands
        ? this.brands
            .map((val) => ({ value: val.id, text: val.marca_name }))
            .push({ value: true, text: 'Otra Marca' })
        : []
    },
    modelOptions() {
      return this.models
        ? this.models
            .map((val) => ({ value: val.id, text: val.model_name }))
            .push({ value: true, text: 'Otro Modelo' })
        : []
    },
  },
  watch: {
    ot() {
      this.fetchEquipment()
    },
    equipment() {
      this.formEquipo = this.equipment || {}
      if (this.formEquipo && this.formEquipo.serial_number) {
        this.loadedSerial = true
      }
    },
    async query(serial) {
      if (!serial) return
      this.debouncedSearchSerial(serial)
    },
  },
  async created() {
    if (this.n_serie_ov) {
      this.loadingFromCreated = true
      this.query = this.n_serie_ov
    } else {
      this.fetchEquipment()
    }
  },
}
</script>

<style scoped lang="scss">
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.separator {
  color: #23201c;
  margin: 0 4px;
}

.samtek-label {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #23201c;
  display: block;
  margin-bottom: 6px;
}

.samtek-section-subtitle {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #23201c;
  margin-bottom: 12px;
}

.serial-search-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.serial-input-wrapper {
  position: relative;
  flex: 1;
  min-width: 240px;
  max-width: 400px;

  .serial-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #525252;
    z-index: 10;
    pointer-events: none;
  }

  .serial-typeahead {
    ::v-deep input {
      padding-left: 34px !important;
      border: 1px solid #525252 !important;
      border-radius: 5px !important;
      font-family: 'Noto Sans', sans-serif;
      font-size: 15px;
      height: 40px;

      &:focus {
        border-color: #fece2f !important;
        box-shadow: 0 0 0 2px rgba(254, 206, 47, 0.25) !important;
      }
    }
  }
}

.serial-loaded-text {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  color: #23201c;
  font-size: 0.95rem;
}

.button-wrapper {
  width: 100%;
  display: flex;
  gap: 1rem;

  @include media-breakpoint-down(sm) {
    flex-direction: column;
  }
}

.samtek-btn-primary {
  min-width: 130px;
  height: 45px;
  padding: 10px 20px;
  background-color: #fece2f;
  color: #23201c;
  border: none;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.88;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  @include media-breakpoint-down(sm) {
    width: 100%;
  }
}

::v-deep .samtek-btn-secondary {
  min-width: 130px;
  flex-shrink: 0;
  height: 45px;
  padding: 10px 20px;
  background-color: #f5f6fa;
  color: #23201c;
  border: 1px solid #525252;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s;

  &:hover {
    background-color: #e8e9ef;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  @include media-breakpoint-down(sm) {
    width: 100%;
  }
}
</style>
